module.exports = __webpack_public_path__ + "media/images/anuba.logo-22704a64c64a1894397db8f5be35f20a.svg";